function setCookie(name,value,minutes) {
  var expires = "";
  if (minutes) {
    var date = new Date();
    date.setTime(date.getTime() + (minutes * (60 * 1000)));
    expires = "; expires=" + date.toUTCString();
  }
  //document.cookie = name + "=" + (date.toUTCString() || "")  + expires + "; path=/";
  document.cookie = name +'=' + value + ';' + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

function eraseCookie(name) {   
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

/**************************************************************/

$(document).ready(function() {
  let itemsTotal = null;
  let items = null;

  function showMessage(users, item) {
    $('#trID-' + item + ' .incentive span.label').text(users + ' Personas más tienen esta pieza en su carrito.')
    $('#trID-' + item + ' .incentive').addClass('active');
  } 

  let cookie_cart_users = getCookie('cart_users');
  let cookie_cart_items = getCookie('cart_items');

  if(cookie_cart_users == null && cookie_cart_items == null) {
    $.getJSON('/cart.js', function(cart) {
      itemsTotal = cart.items.length;
      items = cart.items;

      /* Carrito */
      if (itemsTotal > 1) {
        var min_items = 1;
        var max_items = cart.items.length;
        var random_number_items = Math.floor((Math.random() * max_items) + min_items);
      } else {
        var random_number_items = 1;
      }

      /* Usuarios */
      var min_users = 2;
      var max_users = 6;
      var random_number_users = Math.floor((Math.random() * max_users) + min_users);

      setCookie('cart_users', random_number_users, 12);
      setCookie('cart_items', random_number_items, 12);
      
      showMessage(random_number_users, random_number_items);
    });
  } else {
    showMessage(cookie_cart_users, cookie_cart_items);
  }
}); 